/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IIconStyles } from "office-ui-fabric-react/lib/Icon";

import { getTheme } from "@fluentui/react";

const theme = getTheme();

export const copyIconStyles: IIconStyles = {
  root: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.blue,
  },
};
